module.exports = __webpack_public_path__ + "img/bin.c531bf33.svg";